import { Injectable } from '@angular/core';
import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { IErrorStatus } from '@nimbus-global/features/shared/models/api/i-error-status.model';
import { AlertType } from '@nimbus-library/features/modal/components/confirm-modal/confirm-modal.component';
import { IErrorHandlerOption } from '@nimbus-library/features/shared/services/error-handler.service';
import { BaseErrorCodeProviderService } from '@nimbus-library/features/shared/services/base-error-code-provider.service';

export enum ProvisioningErrorFECodes {
  DownloadError = 'PV0001-FE',
}

@Injectable()
export class ErrorCodeProviderService extends BaseErrorCodeProviderService {
  private readonly errorCodes: IMap<(x: IErrorStatus) => IErrorHandlerOption> = {
    PV0000: (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    PV0001: (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    PV0002: (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    PV0003: (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    PV0004: (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    WFM4040: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'The referenced resource is not found.',
    }),
    WFM4041: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Workflow template is not found.',
    }),
    WFM4042: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'The workflow has been deleted.',
    }),
    WFM4043: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Your service has been suspended.',
    }),
    WFM4044: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Your service has been deleted.',
    }),
    WFM4090: (x: IErrorStatus) => ({
      title: 'Warning',
      actions: [],
      alertType: AlertType.Warning,
      confirmText: 'Reload',
      message: 'The selected Workflow has been updated by someone else. Please reload to get the most recent updates.',
    }),
    WFM4221: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Something went wrong, please contact your Administrator.',
    }),
    WFM4222: (x: IErrorStatus) => ({
      title: 'Workflow Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: `The referenced file (${x.error.Exception.Data.ResourceId}) does not exist.`,
    }),
    ML4221: (x: IErrorStatus) => ({
      title: 'Media Library Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: `The referenced file (${x.error.Data.Field}) does not exist.`,
    }),
    ML4222: (x: IErrorStatus) => ({
      title: 'Media Library Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: `You do not have rights to use this file (${x.error.Data.Field})`,
    }),
    ML4223: (x: IErrorStatus) => ({
      title: 'Media Library Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Media file is in use, it cannot be deleted',
    }),
    ML4224: (x: IErrorStatus) => ({
      title: 'Media Library Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Playist is in use, it cannot be deleted',
    }),
  };

  public constructor() {
    super();
    this.errorCodes[ProvisioningErrorFECodes.DownloadError] = (x: IErrorStatus) => ({
      title: 'Provisioning Error',
      actions: [],
      alertType: AlertType.Error,
      confirmText: 'Ok',
      message: 'Download error, please try again.',
    });
  }

  public getErrorCodes() {
    return this.errorCodes;
  }
}
